export default "__VITE_ASSET__Dl0GzET4__"